export default __webpack_public_path__ + "static/images/Mina_6.png";